import React from "react";
import NavBar from "./navBar";

const HomeComponent = props => {
    return (
       <NavBar activeComponent={"home"}/>
    )
}

export default HomeComponent